'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResourceTimings = exports.NavigationTimings = exports.FULLY_LOADED_THRESHOLD = exports.EVENT_NAMES = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _deepAssign = require('deep-assign');

var _deepAssign2 = _interopRequireDefault(_deepAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isNumber = function isNumber(val) {
    return typeof val === 'number';
};
var isObject = function isObject(val) {
    return (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
};

var EVENT_NAMES = exports.EVENT_NAMES = {
    FULLY_LOADED: 'fullyLoaded',
    TTFB: 'TTFB'
};
var FULLY_LOADED_THRESHOLD = exports.FULLY_LOADED_THRESHOLD = 2000;

/**
 * Get metrics we care about derived from the navigation performance API, e.g.,
 * TTFB (time to first byte)
 *
 * Once the class is instantiated it waits for the window's onLoad event before
 * fetching the timings. The timings can then be peeked and poped. Popping
 * ensures that metrics are only sent once.
 *
 * @see https://www.w3.org/TR/navigation-timing/#sec-window.performance-attribute
 */

var NavigationTimings = exports.NavigationTimings = function () {
    function NavigationTimings() {
        var _this = this;

        _classCallCheck(this, NavigationTimings);

        this.timings = {};

        this.populateNavigationTimings = this.populateNavigationTimings.bind(this);

        ['populateNavigationTimings', 'pop', 'peek'].forEach(function (method) {
            _this[method] = _this[method].bind(_this);
        });

        // get derived navigation timings on load
        window.addEventListener('DOMContentLoaded', this.populateNavigationTimings);
    }

    _createClass(NavigationTimings, [{
        key: 'populateNavigationTimings',
        value: function populateNavigationTimings() {
            this.timings = {};

            if (window.performance && window.performance.timing && isObject(window.performance.timing)) {
                var _window$performance$t = window.performance.timing,
                    requestStart = _window$performance$t.requestStart,
                    responseStart = _window$performance$t.responseStart;


                if (isNumber(requestStart) && isNumber(responseStart)) {
                    this.timings[EVENT_NAMES.TTFB] = responseStart - requestStart;
                }
            }

            return this.timings;
        }

        /**
         * Retrieve timings and clear
         * @returns {Object} timings
         */

    }, {
        key: 'pop',
        value: function pop() {
            var poppedTimings = (0, _deepAssign2.default)({}, this.timings);
            this.timings = {};
            return poppedTimings;
        }

        /**
         * Retrieve timings but do not clear
         * @returns {Object} timings
         */

    }, {
        key: 'peek',
        value: function peek() {
            return this.timings;
        }
    }]);

    return NavigationTimings;
}();

/**
 * Get metrics we care about derived from the resource performance API.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API
 */


var ResourceTimings = exports.ResourceTimings = function () {
    function ResourceTimings() {
        var _this2 = this;

        _classCallCheck(this, ResourceTimings);

        this.fullyLoadedTimesFoundCount = 0;

        ['getFullyLoadedTime', 'getFullyLoadedTimeOnce'].forEach(function (method) {
            _this2[method] = _this2[method].bind(_this2);
        });
    }

    /**
     * Get the "fully loaded" time, i.e., the completion time of the first
     * network request that is followed by at least 2 sec of network silence.
     *
     * If no 2-second gap is found, or if the browser doesn't support the
     * necessary resource timing properties (*cough* *cough* IE), an empty {}
     * will be returned.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming
     */


    _createClass(ResourceTimings, [{
        key: 'getFullyLoadedTime',
        value: function getFullyLoadedTime() {
            var resources = window.performance.getEntriesByType('resource') || [];
            if (resources.length <= 0) {
                console.warn('no resource perf records available');
                return {};
            }

            for (var i = 0; i < resources.length; i += 1) {
                var resource = resources[i];

                // undefined if out of bounds
                var nextResource = resources[i + 1];
                var nextStartTime = nextResource ? nextResource.startTime : window.performance.now();

                if (!resource.startTime || !resource.responseEnd) {
                    console.warn('required resource perf props not supported by browser');
                    return {};
                }

                if (nextStartTime - resource.responseEnd >= FULLY_LOADED_THRESHOLD) {
                    this.fullyLoadedTimesFoundCount += 1;
                    return _defineProperty({}, EVENT_NAMES.FULLY_LOADED, resource.responseEnd);
                }
            }

            // no gap longer than threshold found
            return {};
        }

        /**
         * Get the "fully loaded" time, but only once. If called after a fully-
         * loaded time has already been returned, return {}
         */

    }, {
        key: 'getFullyLoadedTimeOnce',
        value: function getFullyLoadedTimeOnce() {
            if (this.fullyLoadedTimesFoundCount < 1) {
                return this.getFullyLoadedTime();
            }
            return {};
        }
    }]);

    return ResourceTimings;
}();


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/client-profiler-core/dist/utils/BrowserTimings.js
// module id = 511
// module chunks = 5